import React, { useContext, useEffect } from "react";

import ThumbsContext from "contexts/contextThumbs";
import DatabaseContext from "data/contextDatabase";

import { useThumbsDex } from "hooks/dexHooks";
import { shouldLog } from "utils/shouldLog";

const timer = new Date().getTime();

const ThumbSetter = (props) => {
  const { databaseState } = useContext(DatabaseContext);
  const { thumbsDispatch } = useContext(ThumbsContext);
  const { liveThumbs } = useThumbsDex(databaseState.dexUser);

  useEffect(() => {
    let mounted = true;
    let j = {};
    if (liveThumbs && mounted) {
      liveThumbs.forEach((t) => (j[t.mpersona] = t.thumb));
      thumbsDispatch({
        type: "SET_THUMBS",
        values: { thumbs: j }
      });
    }
    return () => {
      mounted = false;
    };
  }, [thumbsDispatch, liveThumbs]);

  shouldLog() && console.log("ThumbSetter timer", new Date().getTime() - timer);
  return null;
};

export default React.memo(ThumbSetter, (prevProps, nextProps) => {
  return true;
});
